import React from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMedal } from '@fortawesome/free-solid-svg-icons';
import { faAward } from '@fortawesome/free-solid-svg-icons';


const CertificateFAPage = () => {
  const authState = useSelector(state => state.authReducer);
  const user = useSelector(state => state.user);
  const certcount = 22;
  const trophiescount = certcount / 5;

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', color: 'white' }}>
      <FontAwesomeIcon icon={faMedal} style={{ fontSize: '4em', color: 'green', marginBottom: '20px' }} />
      <div style={{ textAlign: 'center' }}>
        <h2>
          {authState.user && authState.user.name
            ? `Hello ${authState.user.name}! You have earned ${Math.floor(certcount)} Certificates`
            : `Hello! You have earned ${Math.floor(certcount)} Certificates`}
        </h2>
      </div>
      <FontAwesomeIcon icon={faAward} style={{ fontSize: '4em', color: 'green', marginTop: '20px' }} />
      <div style={{ textAlign: 'center', fontSize: '24px' }}>
      <p>Rule - For Every 5 Certificates You Earn, Get 1 Trophy.</p>
    </div>
    </div>
  );
};

export default CertificateFAPage;
